import { Box, Button } from "@chakra-ui/react";
import { KYDAdminEvent } from "@common/interfaces/KYDEvent";
import { keyframes } from "@emotion/react";

const LaunchEventButton = ({
  kydEvent,
  onLaunchEvent,
  loading,
}: {
  loading: Record<string, boolean>;
  onLaunchEvent: () => void;
  kydEvent?: KYDAdminEvent;
}) => {
  if (!kydEvent) {
    return null;
  }

  const hasDescription = kydEvent?.description;

  return kydEvent.ticket_types.filter((tt) => tt.status === "DRAFT").length >
    0 &&
    kydEvent.image &&
    kydEvent.status !== "PENDING_APPROVAL" &&
    hasDescription ? (
    <Box
      bg="white"
      borderWidth={"1px"}
      borderColor={"gray.100"}
      roundedTop={"lg"}
      p={4}
      w="100%"
      shadow={"lg"}
      bottom={0}
      position={"sticky"}
    >
      <Button
        onClick={() => onLaunchEvent()}
        isDisabled={loading["blocking"]}
        isLoading={loading["blocking"]}
        background="linear-gradient(-45deg, #FFA63D, #FF3D77, #338AFF, #3CF0C5)"
        backgroundSize="600%"
        color="white"
        w="100%"
        h="50px"
        _hover={{ backgroundColor: "none" }}
      >
        {`Launch ${kydEvent.status === "OPEN" ? "Changes" : "Event"} 🚀`}
      </Button>
    </Box>
  ) : null;
};

export default LaunchEventButton;
